import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'aktivasi',
        path: `${AUTH_PREFIX_PATH}/aktivasi`,
        component: React.lazy(() => import('views/auth-views/authentication/aktivasi')),
    },
    {
        key: 'reset',
        path: `${AUTH_PREFIX_PATH}/reset`,
        component: React.lazy(() => import('views/auth-views/authentication/reset')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: 'calon_mhs.biodata',
        path: `${APP_PREFIX_PATH}/calon_mhs/biodata`,
        component: React.lazy(() => import('views/app-views/calon_mhs/Biodata')),
    },
    {
        key: 'calon_mhs.prestasi',
        path: `${APP_PREFIX_PATH}/calon_mhs/prestasi`,
        component: React.lazy(() => import('views/app-views/calon_mhs/Prestasi')),
    },
    {
        key: 'calon_mhs.pendidikan',
        path: `${APP_PREFIX_PATH}/calon_mhs/pendidikan`,
        component: React.lazy(() => import('views/app-views/calon_mhs/Pendidikan')),
    },
    {
        key: 'calon_mhs.dokumen',
        path: `${APP_PREFIX_PATH}/calon_mhs/dokumen`,
        component: React.lazy(() => import('views/app-views/calon_mhs/Dokumen')),
    },
    {
        key: 'calon_mhs.konfirmasi',
        path: `${APP_PREFIX_PATH}/calon_mhs/konfirmasi`,
        component: React.lazy(() => import('views/app-views/calon_mhs/Konfirmasi')),
    },
    {
        key: 'calon_mhs.pekerjaan',
        path: `${APP_PREFIX_PATH}/calon_mhs/pekerjaan`,
        component: React.lazy(() => import('views/app-views/calon_mhs/Pekerjaan')),
    },
]
